<template>
	<div class="status">
		<div v-for="message in contentMessages"
			:key="message.id"
			v-bind:class="['message', {
				warning: message.status != 'ready' && message.status != 'sent',
				success: message.status === 'sent'
			}]">
			<el-tooltip
				class="item" effect="dark"
				:content="formatDate(message.time)"
				placement="top">
				<i v-if="message.status != 'ready'" v-bind:class="{
		  		  'unverified': 'el-icon-warning',
		  		  'sent': 'el-icon-success'
		  	  }[message.status]"></i>
    </el-tooltip>

		</div>
	</div>
</template>
<script>
import ScheduledMessages from '../mixin/messages'

export default {
	name: 'schedule-message-status',
	mixins: [ ScheduledMessages ]
}
</script>
<style lang="scss">
@import "./style.scss";
</style>
